// import { ResponsiveHoneycomb, Hexagon } from "react-honeycomb";
// import { useRef, useState, useEffect } from "react";
// import range from "lodash/range";
// import "./Honeycomb.css";

// const items = range(192);
// const sideLength = 64;

// export default function Honeycomb() {
//   const containerRef = useRef(null);
//   const [highlightMap, setHighlightMap] = useState({});
//   const [hexesPerRow, setHexesPerRow] = useState(0);

//   const hexWidth = sideLength * 2;

//   // Utility: Get row-wise hex index with optional offset
//   const getVisualCenter = (rowIndex, perRow, offset = 0) => {
//     const center = Math.floor(perRow / 2);
//     return rowIndex * perRow + center + offset;
//   };

//   useEffect(() => {
//     const resizeObserver = new ResizeObserver((entries) => {
//       const width = entries[0].contentRect.width;
//       const perRow = Math.floor(width / hexWidth);
//       setHexesPerRow(perRow);

//       const map = {};

//       // Row 1 center
//       map[getVisualCenter(0, perRow)] = {
//         label: "Utah Data (Home)",
//         bgColor: "#3b82f6", // Blue
//       };

//       // Row 3 center (with visual offset)
//       map[getVisualCenter(2, perRow, 4)] = {
//         label: "Utah Verticals",
//         bgColor: "#c084fc", // Purple
//       };

//       // Row 4 hex 6–11
//       const row4Start = 3 * perRow + 5;
//       const row4Labels = [
//         "Manufacturing",
//         "Information",
//         "Engineering & Technology",
//         "Food Industry",
//         "Aerospace",
//         "BFM (Business Fnance Marketing",
//       ];
//       row4Labels.forEach((label, i) => {
//         map[row4Start + 6 + i] = {
//           label,
//           bgColor: "#facc15", // Yellow
//         };
//       });

//       // Row 5 center
//       map[getVisualCenter(5, perRow, -6)] = {
//         label: "Utah At A Glance",
//         bgColor: "#c084fc", // Blue
//       };

//       // ✅ Row 6 hex 6–11
//       const row6Start = 5 * perRow + 4;
//       const row6Labels = [
//         "Charging Stations",
//         "Utah Housing",
//         "Utah Counties",
//         "Utah State",
//         "Utah Voters Count",
//         "Education & Resources",
//         "Utah Cities",
//         "Utah Universities",
//         "Utah Schools",
//         "Demographics",
//         "Jobs",
//         "Geothermal",
//         "Airports",
//         "MLM",
//         "Hospital",
//         "Air Quality",
//         "Tax",
//         "Zipcode",
//         "Utah Libraries",
//       ];
//       row6Labels.forEach((label, i) => {
//         map[row6Start + 6 + i] = {
//           label,
//           bgColor: "#4ade80", // Green
//         };
//       });

//       // Row 9 center
//       map[getVisualCenter(9, perRow, 2)] = {
//         label: "Others",
//         bgColor: "#c084fc", // Blue
//       };

//       // ✅ Row 10 hex 6–11
//       const row10Start = 10 * perRow + 1;
//       const row10Labels = [
//         "Login",
//         "About",
//         "Privacy Policy",
//         "Contact Us",
//         "Gallery",
//         "KCG",
//         "Ask Betsy AI",
//         "NAICS",
//         "Copyright",
//         "WIP",
//       ];
//       row10Labels.forEach((label, i) => {
//         map[row10Start + 6 + i] = {
//           label,
//           bgColor: "#F8C6A1", // Green
//         };
//       });

//       setHighlightMap(map);
//     });

//     if (containerRef.current) {
//       resizeObserver.observe(containerRef.current);
//     }

//     return () => {
//       if (containerRef.current) {
//         resizeObserver.unobserve(containerRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div ref={containerRef}>
//       <ResponsiveHoneycomb
//         defaultWidth={1024}
//         size={sideLength}
//         items={items}
//         renderItem={(item, index) => {
//           const match = highlightMap[index];
//           const isHighlighted = !!match;

//           return (
//             <Hexagon
//               key={index}
//               className={isHighlighted ? "hexagon-box" : ""}
//               style={{
//                 backgroundColor: isHighlighted ? match.bgColor : "#f0f0f0",
//                 color: isHighlighted ? "#ffffff" : "#000000",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 textAlign: "center",
//                 fontWeight: "bold",
//                 fontSize: "13px",
//                 padding: "8px",
//                 cursor: `url("https://cur.cursors-4u.net/animals/ani-10/ani978.png"), auto`,
//                 // cursor: "pointer",
//                 // transition: "all 0.3s ease-in-out",
//                 // transform: "scale(1)",
//                 boxShadow: isHighlighted
//                   ? "0 0 12px rgba(0, 0, 0, 0.2)"
//                   : "none",
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.boxShadow =
//                   "0 0 16px rgba(0, 123, 255, 0.6)";
//                 e.currentTarget.style.transform = "scale(1.05)";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.boxShadow = isHighlighted
//                   ? "0 0 12px rgba(0, 0, 0, 0.2)"
//                   : "none";
//                 e.currentTarget.style.transform = "scale(1)";
//               }}
//             >
//               <div>{match?.label}</div>
//             </Hexagon>
//           );
//         }}
//       />
//     </div>
//   );
// }

// Honeycomb.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { ResponsiveHoneycomb, Hexagon } from "react-honeycomb";
import range from "lodash/range";
import "./Honeycomb.css";

const sideLength = 64;
const ROW_LENGTH = 16; // fixed number of columns per row
const TOTAL_ROWS = 12;

const labeledHexes = [
  { row: 0, col: 7, label: "Utah Data (Home)", bgColor: "#3b82f6", path: "/" },
  {
    row: 2,
    col: 7,
    label: "Utah Verticals",
    bgColor: "#c084fc",
    path: "/verticals",
  },
  {
    row: 3,
    col: 5,
    label: "Manufacturing",
    bgColor: "#facc15",
    path: "/verticals/manufacturing",
  },
  {
    row: 3,
    col: 6,
    label: "Information",
    bgColor: "#facc15",
    path: "/verticals/information",
  },
  {
    row: 3,
    col: 7,
    label: "Professional, Scientific, & Technical Services",
    bgColor: "#facc15",
    path: "/verticals/engineering-and-technology",
  },
  {
    row: 3,
    col: 8,
    label: "Food Industry",
    bgColor: "#facc15",
    path: "/verticals/food",
  },
  {
    row: 3,
    col: 9,
    label: "Aerospace",
    bgColor: "#facc15",
    path: "/verticals/aerospace",
  },
  {
    row: 3,
    col: 10,
    label: "BFM (Business Finance Marketing)",
    bgColor: "#facc15",
    path: "/verticals/business-finance-marketing",
  },
  {
    row: 4,
    col: 7,
    label: "Utah At A Glance",
    bgColor: "#c084fc",
    path: "/utah-at-a-glance",
  },

  {
    row: 5,
    col: 0,
    label: "Charging Stations",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/charging-stations",
  },
  {
    row: 5,
    col: 1,
    label: "Utah Housing",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/utah-housing",
  },
  {
    row: 5,
    col: 2,
    label: "Utah Counties",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/utah-counties",
  },
  {
    row: 5,
    col: 3,
    label: "Utah State",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/utah-state",
  },
  {
    row: 5,
    col: 4,
    label: "Utah Voters Count",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/utah-voterscount",
  },
  {
    row: 5,
    col: 5,
    label: "Education & Intellectual Resources",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/universities-and-schools",
  },
  {
    row: 5,
    col: 6,
    label: "Utah Cities",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/utah-cities",
  },
  {
    row: 5,
    col: 7,
    label: "Utah Universities",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/universities-and-schools/utah-universities",
  },
  {
    row: 5,
    col: 8,
    label: "Utah Schools",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools",
  },
  {
    row: 5,
    col: 9,
    label: "Demographics",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/demographics",
  },
  {
    row: 5,
    col: 10,
    label: "Jobs",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/jobs",
  },
  {
    row: 5,
    col: 11,
    label: "Geothermal",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/geothermal",
  },
  {
    row: 5,
    col: 12,
    label: "Airports",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/airports",
  },
  {
    row: 5,
    col: 13,
    label: "MLM",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/mlm",
  },
  {
    row: 5,
    col: 14,
    label: "Utah Hospitals",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/hospitals",
  },
  {
    row: 5,
    col: 15,
    label: "Air Quality",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/air-quality",
  },
  {
    row: 6,
    col: 0,
    label: "Taxes",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/taxes",
  },
  {
    row: 6,
    col: 1,
    label: "Zipcode",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/zipcodes",
  },
  {
    row: 6,
    col: 2,
    label: "Utah Libraries",
    bgColor: "#4ade80",
    path: "/utah-at-a-glance/utah-libraries",
  },

  { row: 8, col: 7, label: "Others", bgColor: "#c084fc", path: "" },

  { row: 9, col: 3, label: "Login", bgColor: "#F8C6A1", path: "/login" },
  { row: 9, col: 4, label: "About", bgColor: "#F8C6A1", path: "/about" },
  {
    row: 9,
    col: 5,
    label: "Privacy Policy",
    bgColor: "#F8C6A1",
    path: "/privacy-policy",
  },
  {
    row: 9,
    col: 6,
    label: "Contact Us",
    bgColor: "#F8C6A1",
    path: "/contact-us",
  },
  { row: 9, col: 7, label: "Gallery", bgColor: "#F8C6A1", path: "/gallery" },
  { row: 9, col: 8, label: "KCG", bgColor: "#F8C6A1", path: "/kcg" },
  {
    row: 9,
    col: 9,
    label: "Ask Betsy AI",
    bgColor: "#F8C6A1",
    path: "/search",
  },
  { row: 9, col: 10, label: "NAICS", bgColor: "#F8C6A1", path: "/get-naics" },
  {
    row: 9,
    col: 11,
    label: "Copyright",
    bgColor: "#F8C6A1",
    path: "/copyright",
  },
  { row: 9, col: 12, label: "WIP", bgColor: "#F8C6A1", path: "/wip" },
];

// Convert to map with linear index
const highlightMap = {};
labeledHexes.forEach(({ row, col, label, bgColor, path }) => {
  const index = row * ROW_LENGTH + col;
  highlightMap[index] = { label, bgColor, path };
});

export default function Honeycomb() {
  const navigate = useNavigate();

  return (
    <div className="honeycomb-container">
      <ResponsiveHoneycomb
        defaultWidth={1920}
        size={sideLength}
        items={range(ROW_LENGTH * TOTAL_ROWS)}
        renderItem={(item, index) => {
          const match = highlightMap[index];
          const isHighlighted = !!match;

          return (
            <Hexagon
              key={index}
              className={isHighlighted ? "hexagon-box" : ""}
              style={{
                backgroundColor: isHighlighted ? match.bgColor : "#f0f0f0",
                color: isHighlighted ? "#ffffff" : "#000000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "13px",
                padding: "8px",
                cursor: "pointer",
                boxShadow: isHighlighted
                  ? "0 0 12px rgba(0, 0, 0, 0.2)"
                  : "none",
                zIndex: 1,
              }}
            >
              <div
                onClick={() => match?.path && navigate(match.path)}
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents: "auto",
                }}
              >
                {match?.label}
              </div>
            </Hexagon>
          );
        }}
      />
    </div>
  );
}

